'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const cards = [
  { image: '/image/2026/10/14/hk_pms_1_v2.jpg', key: 'item1' },
  { image: '/image/2026/10/14/hk_pms_2_v2.jpg', key: 'item2' },
  { image: '/image/2026/10/14/hk_pms_3_v2.jpg', key: 'item3' },
]

const MOBILE_AUTOPLAY = {
  delay: 3000,
  stopOnInteraction: false,
  breakpoints: { '(min-width: 1024px)': { active: false } },
}

export const HelloKittyPlayMoveStyle = () => {
  const t = useTranslations('hello_kitty_hardcode.play_move_style')

  return (
    <section className='grid gap-6 bg-[#FAF5EF] px-5 py-10 lg:gap-10 lg:px-15 lg:py-20'>
      <div className='relative grid gap-4 lg:flex lg:items-end lg:justify-between'>
        <h2 className='font-criteria text-[28px] font-semibold uppercase leading-[47px] tracking-[-0.02em] text-[#C20019] lg:text-[80px] lg:font-bold lg:leading-[91px] lg:tracking-[-0.03em]'>
          {t('title_line1')}
          <br />
          {t('title_line2')}
        </h2>
        {/* Mobile: mascot nổi góc trên phải, desktop: mascot nằm cạnh mô tả, căn đáy */}
        <div className='lg:flex lg:items-end lg:gap-[5px]'>
          <p className='text-sm text-[#242424] lg:w-[465px] lg:text-2xl lg:leading-[30px]'>
            {t('description_line1')} <br className='max-lg:hidden' />
            {t('description_line2')}
          </p>
          <Image
            src={ImageHelper.getImageUrlCdn('/image/2026/10/06/hk_mascot.png')}
            alt='Hello Kitty'
            width={435}
            height={435}
            className='absolute -top-6 right-0 w-[118px] lg:static lg:w-[210px] lg:shrink-0'
          />
        </div>
      </div>

      {/* Mobile: slide ngang tự chạy, desktop: tắt slide, 3 card cố định trên 1 hàng */}
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          breakpoints: { '(min-width: 1024px)': { active: false } },
        }}
        plugins={[Autoplay(MOBILE_AUTOPLAY)]}
        className='w-full'
      >
        <CarouselContent className='-ml-4 lg:-ml-6'>
          {cards.map((card) => (
            <CarouselItem
              key={card.key}
              className='basis-[71.2%] pl-4 lg:basis-1/3 lg:pl-6'
            >
              <div className='grid gap-4'>
                <div className='relative aspect-[585/600] overflow-hidden rounded-lg'>
                  <Image
                    src={ImageHelper.getImageUrlCdn(card.image)}
                    alt={t(`${card.key}.title`)}
                    fill
                    sizes='(min-width: 1024px) 33vw, 70vw'
                    className='object-cover'
                  />
                </div>
                <div className='grid gap-1 text-black lg:gap-2'>
                  <h3 className='font-criteria text-base font-bold uppercase leading-6 tracking-[-0.02em] lg:text-xl lg:font-semibold lg:leading-normal'>
                    {t(`${card.key}.title`)}
                  </h3>
                  <p className='text-sm lg:text-base'>
                    {t(`${card.key}.description`)}
                  </p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  )
}
